import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3ab1cfdf&scoped=true"
import script from "./Index.vue.js?vue&type=script&lang=js&external"
export * from "./Index.vue.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=3ab1cfdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1cfdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
